<template>
    <div ref="modal" class="modal fade" :class="{ show: active, 'd-block': active }" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ type.charAt(0).toUpperCase() + type.slice(1) + " Cost Header"}}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" v-on:click="$emit('closeModal')"
              aria-label="btn-close"></button>
          </div>
  
          <form class="forms-sample" method="POST" ref="formElement" @submit.prevent="submitData">
            <div class="modal-body">
             
  
           
  
            
              <!--end::loading-data-->
              <!-- <h5>{{ $t("areYouSure") }}</h5> -->
              <div class="mb-3" >
                <div class="form-group row">
                    <label class="col-sm-2 col-form-label"><b>Add Cost Code</b></label>
                    <div class="col-sm-10">
                        <input type="text" class="form-control" v-model="forms.add_cost_code" disabled>
                    </div>
                </div>
              </div>
              <div class="mb-3" >
                <div class="form-group row">
                    <label class="col-sm-2 col-form-label"><b>Add Cost Name</b></label>
                    <div class="col-sm-10">
                        <input type="text" class="form-control" v-model="forms.add_cost_name">
                    </div>
                </div>
              </div>
              <div class="mb-3" >
                <div class="form-group row">
                    <label class="col-sm-2 col-form-label"><b>Type</b></label>
                    <div class="col-sm-10">
                        <!-- <select class="form-control" v-model="forms.type">
                            <option value="ASIS">ASIS</option>
                        </select> -->

                        <v-select :options="['ASIS']" v-model="forms.type">

                        </v-select>
                    </div>
                </div>
              </div>
              <div class="mb-3" >
                <div class="form-group row">
                    <label class="col-sm-2 col-form-label"><b>Value</b></label>
                    <div class="col-sm-10">
                        <input type="text" class="form-control" disabled v-model="forms.nominal">
                    </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12">
                    <div class="card">
                        <div class="card-header">
                            <button  type="button" @click="addRow" class="btn-success btn btn-sm float-end btn-icon">
                                <i class="mdi mdi-plus"></i> 
                            </button>
                        </div>  
                        <div class="card-body">
                            <table class="table table-responsive">
                                <thead>
                                    <tr>
                                        <th>Charge Code</th>
                                        <th>Charge Name</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(list,key) in chargeDetail" :key="key">
                                        <td>
                                            <multiselect ref="inputChargeCode" @open="removeReadonly(key)" :searchable="true" @search-change="asyncChargeCode"  v-model="list.charge" :show-labels="false" :options="fetchChargeList" placeholder="Please Select" track-by="edi_code" :id="`fieldInput-${key}`" @input="changeChargeDetail($event,key)" label="edi_code">
                                              <template slot="option" slot-scope="props">
                                                {{ props.option.edi_code }} - {{ props.option.description_overide }}
                                              </template>
                                            </multiselect>
                                        </td>
                                        <td>{{ list.charge_name }}</td>
                                        <td>
                                            <button type="button" class="btn btn-danger btn-icon" @click="chargeDetail.splice(key, 1)">
                                                <i class="mdi mdi-delete"></i>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
              </div>
 
           
  
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" v-on:click="$emit('closeModal')">
                Cancel
              </button>
              
              <div v-if="isLoading" class="d-flex align-items-center">
                <div class="spinner-border ms-auto" role="status" aria-hidden="true"></div>
                <strong>Loading...</strong>
              </div>
  
              <button v-if="!isLoading" class="btn btn-primary" type="submit">Save </button>
  
            </div>
          </form>
        </div>
      </div>
    </div>
  </template>
    
  <script>
  import multiselect from "vue-multiselect";

  export default {
    components: {
        multiselect: multiselect,
    },
    name: "modalAddCostForm",
    emits: ["closeModal"],
  
    props: {
      showModal: Boolean,
      data: null,
      type: String,
    },
    watch: {
      showModal: {
        handler(newVal) {
          this.active = newVal;
          const body = document.querySelector("body");
          this.showModal
            ? body.classList.add("modal-open")
            : body.classList.remove("modal-open");
            console.log(this.data);
            if(this.data){
                if(this.type == 'add'){
                    this.forms = {
                        nominal:0,
                    };
                    this.forms.company_id = this.data?.company_id ? this.data.company_id : null;
                    this.forms.company_name = this.data?.company_name ? this.data.company_name : null;
                    this.chargeDetail = [];
                }

                if(this.type == 'edit'){
                    this.forms.charge_code_header_id = this.data.charge_header.charge_code_header_id;
                    this.forms.add_cost_code = this.data.charge_header.add_cost_code;
                    this.forms.add_cost_name = this.data.charge_header.add_cost_name;
                    this.forms.type = this.data.charge_header.type;
                    this.forms.nominal = this.data.charge_header?.nominal ? this.data.charge_header.nominal : 0;
                    console.log("masuk");
                    let charge_code = this.data.charge_header?.charge_code ? this.data.charge_header?.charge_code : [];
                    if(charge_code.length <= 0){
                        this.chargeDetail = [];
                    }else{
                      this.chargeDetail = charge_code.map((item) => {
                          return {
                              charge_code: item.charge_code,
                              charge:{
                                  edi_code: item.charge_code,
                                  description_overide: item.charge_name,
                              },
                              charge_name: item.charge_name,
                          }
                      });
                    }

                    console.log(this.chargeDetail);
                }
            }
        },
        immediate: true,
        deep: true,
      },
    },
    data() {
      return {
        users:'',
        fetchUser:[],
        aksesmasters:'',
        fetchAksesMaster:[],
        fetchEmailNotification:[],
        emailNotification:'',
        isLoading: false,
        active: this.showModal,
        forms: {
            nominal:0,
        },
        chargeDetail:[],
        fetchChargeList:[],
      };
    },
    methods: {
        changeChargeDetail(event, key) {
            if(event){
                let detail = this.chargeDetail;
                
                let selectedCode = event.edi_code.trim();
                let check = false;
                detail.forEach((item) => {
                    if(item.charge_code == selectedCode && item != detail[key]){
                        check = true;
                    }
    
                });
                if(!check){
                    detail[key].charge_code = event.edi_code.trim();
                    detail[key].charge_name = event.description_overide.trim();
                }else{
                    this.error('Charge Code Already Exist');
                    detail.splice(key, 1);
                }
    
                this.chargeDetail = detail;
            }else{
                this.chargeDetail[key].charge_code = '';
                this.chargeDetail[key].charge_name = '';
            }

        },  
        addRow(){
            this.chargeDetail.push({
                charge_code: [],
                charge_name: "",
            });
        },
      resetForm() {
        this.forms = {
            nominal:0,
        };
        this.chargeDetail = [];
      },
       
      loadChargeCode() {
       
          const baseURI = this.$settings.endPoint+`rm-charge-code/`;
        return this.$http.get(baseURI).then((response) => {
            this.fetchChargeList = response.data.datas.data
        });
      },
      asyncChargeCode(ev) {
       this.fetchChargeList = [];
          const baseURI = this.$settings.endPoint+`rm-charge-code?edi_code=`+ev;
        return this.$http.get(baseURI).then((response) => {
            this.fetchChargeList = response.data.datas.data
        });
      },
     
      submitData() {
        let sendData = this.forms;
        sendData.charge_code = this.chargeDetail.map((item) => {
            return {
                charge_code: item.charge_code,
                charge_name: item.charge_name,
            }
        });

        let url = this.type == 'add' ? 'v1/company-cost/create' : `/v1/company-cost/update/${this.data.charge_header.charge_code_header_id}`;

        this.isLoading=true;

        if(this.type == 'add'){

            this.$http
              .post(this.$settings.endPointProformaInvoice+url, sendData)
              .then((response) => {
                this.isLoading=false;
                if (response.data.status === 200) {
                
                    this.resetForm();
                    this.$emit("closeModal");
                    this.loadSuccess("Success");
                } else {
                  
                  this.errors = response.data.errors;
                  //this.resultError(response.data.errors);
                  this.loadError(this.errors.message)
                }
    
    
              })
              .catch((error) => {
                this.isloading = false;
                if (error.response) {
                  if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                  
                  }
                }
                
              });
        }else{
            this.$http
              .patch(this.$settings.endPointProformaInvoice+url, sendData)
              .then((response) => {
                this.isLoading=false;
                if (response.data.status === 200) {
                    this.resetForm();
                    this.$emit("closeModal");
                    this.loadSuccess("Success");
                } else {
                  
                  this.errors = response.data.errors;
                  //this.resultError(response.data.errors);
                  this.loadError(this.errors.message)
                }
    
    
              })
              .catch((error) => {
                this.isloading = false;
                if (error.response) {
                  if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                  
                  }
                }
                
              });
        }
      },
  
      resultError(data) {
        var html = "";
        var count = Object.keys(data).length;
        for (var x = 0; x < count; x++) {
          var nameOb = Object.keys(data)[x];
          var objectData = data[nameOb];
          for (var y = 0; y < objectData.length; y++) {
            html += objectData[y] + "<br>";
          }
        }
  
        this.loadError(html);
      },
  
      loadError(pesan) {
        this.$swal({
          backdrop: true,
          title: "Warning",
          html: pesan,
          showConfirmButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
        }).then((result) => {
          if (result.value) {
            this.isLoading=false;
          }
        })
      },

      error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },
  
  
  
      loadSuccess(pesan) {
        this.$swal({
          backdrop: true,
          title: "Success",
          html: pesan,
          showConfirmButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
        }).then((result) => {
          if (result.value) {
            this.isLoading=false;
          }
        })
      },
      
      checkReadonly(){
        const formElement = this.$refs.formElement;
        if (formElement) {
          const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              if (mutation.type === 'attributes' && mutation.attributeName === 'readonly') {
                const inputs = formElement.querySelectorAll('.multiselect__input');
                inputs.forEach(input => {
                  input.removeAttribute('readonly');  // Hapus readonly setiap kali diubah
                });
              }
            });
          });

          const inputs = formElement.querySelectorAll('.multiselect__input');
          inputs.forEach(input => {
            observer.observe(input, { attributes: true });
          });
        }
      },

      removeReadonly(index) {
        this.$nextTick(() => {
            const multiselects = this.$refs.inputChargeCode;
            let input = null;
            
            // When using ref + v-for, it becomes an array
            if (Array.isArray(multiselects)) {
              input = multiselects[index].$el.querySelector('.multiselect__input');
            } else {
              input = multiselects.$el.querySelector('.multiselect__input');
            }

            if (input && input.hasAttribute('readonly')) {
              input.removeAttribute('readonly');
            }
          });
      }
     
    },
    created: function () {
      //this.loadDriver();
  
    },
    mounted() {
        this.loadChargeCode();
      const formElement = this.$refs.formElement;
        if (formElement) {
          const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              if (mutation.type === 'attributes' && mutation.attributeName === 'readonly') {
                const inputs = formElement.querySelectorAll('.multiselect__input');
                inputs.forEach(input => {
                  input.removeAttribute('readonly');  // Hapus readonly setiap kali diubah
                });
              }
            });
          });

          const inputs = formElement.querySelectorAll('.multiselect__input');
          inputs.forEach(input => {
            observer.observe(input, { attributes: true });
          });
        }


      //tail(this.data);
    },
    updated(){
        this.$nextTick(() => {
            this.checkReadonly();
        });
    }
  };
  </script>
    
  <style scoped>
  .modal {
    background: rgba(0, 0, 0, 0.4);
  }
  
  .modal-content {
    background: #fff;
    border-radius: 0px;
    border: none;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
    padding: 0px;
    width: 100%;
    height: 100%;
    margin-left: 0px !important;
  }
  </style>